"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartRebalanceProcessor = exports.SmartRebalanceMaxSupportCoin = exports.SmartRebalanceMinInvestPerCoin = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const TextAndSliderSyncTool_1 = require("../CommonUtils/TextAndSliderSyncTool");
const SRAdvancedSettingData_1 = require("./SRAdvancedSettingData");
const trade_utils_lib_1 = require("trade_utils_lib");
const BotAPI_1 = require("../../BotAPI");
const QUOTE = "USDT";
exports.SmartRebalanceMinInvestPerCoin = 10;
exports.SmartRebalanceMaxSupportCoin = 20;
exports.SmartRebalanceProcessor = Object.assign({ useUserParams: (orderType, subType, investText, investPercent, investActionType, quoteAvailable, rebalanceEnable, rebalanceMode, rebalance_param, stopProfitPercent, stopLossPercent, configCoinFunc, configCoinsFunc, symbolSlippages) => {
        const balance = (0, react_1.useMemo)(() => {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quoteAvailable, 2);
        }, [quoteAvailable]);
        const [parseInvest, parseInvestPercent] = TextAndSliderSyncTool_1.TextAndSliderSyncTool.useGridInvestAndInvestPercent(investActionType, investText, investPercent, balance, 2);
        const maxCount = (0, react_1.useMemo)(() => {
            switch (subType) {
                case TradeAPILib_1.SmartRebalanceSubType.double_coins:
                    return 2;
                case TradeAPILib_1.SmartRebalanceSubType.multi_coins:
                    return exports.SmartRebalanceMaxSupportCoin;
            }
        }, [subType]);
        const defaultCoins = (0, react_1.useMemo)(() => {
            if (subType === TradeAPILib_1.SmartRebalanceSubType.multi_coins) {
                return [];
            }
            const cs = [];
            for (let i = 0; i < maxCount; i++) {
                cs.push({ index: i, symbol: undefined, percent: "0" });
            }
            return cs;
        }, [maxCount, subType]);
        // 用于双币轮动, 可以设置更换第几个;
        const [coins, setCoins] = (0, react_1.useState)(defaultCoins);
        // 用于多币轮动
        const validCoins = (0, react_1.useMemo)(() => {
            return coins.filter((e) => e.symbol !== undefined);
        }, [coins]);
        const configureCoin = (0, react_1.useCallback)((coin) => {
            let tempCoins = coins;
            tempCoins.splice(coin.index, 1, coin);
            setCoins(Array().concat(tempCoins));
        }, []);
        const configureCoins = (0, react_1.useCallback)((coins) => {
            setCoins(coins);
        }, []);
        (0, react_1.useEffect)(() => {
            configCoinFunc && configCoinFunc(configureCoin);
        }, [configCoinFunc]);
        (0, react_1.useEffect)(() => {
            configCoinsFunc && configCoinsFunc(configureCoins);
        }, [configCoinsFunc]);
        const minInvest = (0, react_1.useMemo)(() => {
            // 单个币最小投资100 USDT
            const minCount = 2;
            const length = trade_utils_lib_1.SafeDecimal.max(minCount, coins.length);
            const minD = new trade_utils_lib_1.SafeDecimal(exports.SmartRebalanceMinInvestPerCoin).mul(length);
            return minD.toString();
        }, [coins, subType]);
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minInvest,
                max: balance,
            };
            if (new trade_utils_lib_1.SafeDecimal(parseInvest).lessThan(new trade_utils_lib_1.SafeDecimal(minInvest))) {
                state.state = "small";
            }
            else if (new trade_utils_lib_1.SafeDecimal(parseInvest).greaterThan(new trade_utils_lib_1.SafeDecimal(balance))) {
                state.state = "large";
            }
            return state;
        }, [parseInvest, minInvest, balance]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = [];
            if (!Number(parseInvest)) {
                emptys.push("trade_investment");
            }
            return emptys;
        }, [parseInvest, validCoins, subType]);
        return {
            orderType,
            subType,
            maxCount,
            validCount: validCoins.length,
            validCoins,
            coins,
            invest: parseInvest,
            investPercent: parseInvestPercent,
            balance,
            investState,
            minInvest,
            quote: QUOTE,
            emptyErrors,
            rebalanceEnable,
            rebalance_param,
            rebalanceMode,
            stopProfitPercent,
            stopLossPercent,
            symbolSlippages,
        };
    }, getCreateOrderRequest: (params, $st) => {
        var _a;
        if (params.emptyErrors.length > 0) {
            throw $st("trade_params_not_fill_enough");
        }
        if (params.subType == TradeAPILib_1.SmartRebalanceSubType.double_coins) {
            const validCoinCount = params.validCoins.length;
            if (validCoinCount < 2) {
                throw $st("smart_rebalance_to_choose_coin");
            }
        }
        if (params.subType === TradeAPILib_1.SmartRebalanceSubType.multi_coins) {
            if (params.validCount < 2) {
                throw $st("smart_rebalance_coin_need_more", { min: 2 });
            }
            else if (params.validCount > params.maxCount) {
                throw $st("smart_rebalance_coin_need_less", { max: 10 });
            }
        }
        else {
            if (params.validCount < params.maxCount) {
                throw $st("smart_rebalance_double_coin_need_equal");
            }
        }
        if (params.investState.state === "small") {
            throw $st("trade_error_low_cost", {
                cost: `${params.minInvest} ${params.quote}`,
            });
        }
        else if (params.investState.state === "large") {
            throw $st("trade_error_balance_not_enough");
        }
        const symbolSlippageMap = new Map();
        const symbolSlippages = (_a = params.symbolSlippages) !== null && _a !== void 0 ? _a : [];
        symbolSlippages.forEach((item) => symbolSlippageMap.set(item.base, item.slippage));
        const portfolio = params.coins
            .filter((c) => c.symbol !== undefined)
            .map((c) => {
            var _a;
            return {
                base: c.symbol.base,
                percent: c.percent,
                condition: c.condition,
                condition_direction: c.condition_direction,
                slippage: (_a = symbolSlippageMap.get(c.symbol.base)) !== null && _a !== void 0 ? _a : undefined,
            };
        });
        let totalPercent = 0;
        let coinMap = new Map();
        portfolio.forEach((e) => {
            var _a;
            totalPercent = new trade_utils_lib_1.SafeDecimal(e.percent).add(new trade_utils_lib_1.SafeDecimal(totalPercent)).toNumber();
            const n = (_a = coinMap.get(e.base)) !== null && _a !== void 0 ? _a : 0;
            coinMap.set(e.base, n + 1);
        });
        if (totalPercent !== 1) {
            throw $st("smart_rebalance_percent_can_not_more_than_one");
        }
        let sameBase = "";
        coinMap.forEach((v, k) => {
            if (v > 1) {
                sameBase = k;
            }
        });
        if (sameBase) {
            throw $st("smart_rebalance_can_not_has_same_coin");
        }
        return {
            type: params.orderType,
            subType: params.subType,
            quote: params.quote,
            investment: params.invest,
            portfolio: portfolio,
            rebalance_enabled: params.rebalanceEnable,
            rebalance_param: params.rebalance_param,
            rebalance_trigger_type: params.rebalanceMode,
            profit_stop_percentage: params.stopProfitPercent !== "" ? params.stopProfitPercent : undefined,
            loss_stop_percentage: params.stopLossPercent !== "" ? params.stopLossPercent : undefined,
        };
    }, 
    /**
     * @deprecated Use {@link SmartRebalanceProcessor.getSheetMomentumPeriodDisplay} instead.
     */
    formatTimeNumber: (timeNumber, str) => {
        const m5 = `5${str("strateg_Min")}`;
        const m15 = `15${str("strateg_Min")}`;
        const hour1 = `1${str("strateg_Hour")}`;
        const hour4 = `4${str("strateg_Hour")}`;
        const hour6 = `6${str("strateg_Hour")}`;
        const hour8 = `8${str("strateg_Hour")}`;
        const hour12 = `12${str("strateg_Hour")}`;
        const day1 = `1${str("grid_order_lasting_day")}`;
        const day7 = `7${str("grid_order_lasting_day")}`;
        let periods = {
            "300": m5,
            "900": m15,
            "3600": hour1,
            "14400": hour4,
            "21600": hour6,
            "28800": hour8,
            "43200": hour12,
            "86400": day1,
            "604800": day7,
        };
        return periods[`${timeNumber}`] || timeNumber;
    }, 
    /**
     * 修改滑点设置，支持开单和关单
     * slippage?: string; 开单时必传
     * close_slippage?: string; 关单时必传
     */
    modifySlippage: (params) => {
        return (0, BotAPI_1.sRModifySlippage)(params);
    } }, SRAdvancedSettingData_1.SRAdvancedSettingData);
